import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { MARKS, INLINES } from "@contentful/rich-text-types";

import { ReferenciaTabsContenido } from "../../../interfaces/ReferenciaTabsContenido";
import ClubModerator from "../../molecules/club-moderator/clubModerator";

import "./clubDescription.scss";

const ClubDescription = (props: ReferenciaTabsContenido) => {
  const { 
    tituloPrincipal, 
    descripcion, 
    descripcionEvento, 
    listaTags, 
    nombreModerador,
    cargoModerador,
    fraseModerador,
    redesModerador,
    imagenPrincipal
  } = props.referenciaCursosDestacados[0]

  const RenderBold = (text: any) => {
    return (
      <span className="o-club-desc__right__title">{text}</span>
    )
  }

  const RenderHyperlink = (node: any) => {
    return (
      <a 
        className="o-club-desc__right__link" 
        href={node.data.uri}
        target="_blank"
        rel="noreferrer"
      >
        {node.content[0].value}
      </a>
    );
 };
  
  const options = {
    renderMark: {
      [MARKS.BOLD]: RenderBold
    },
    renderNode: {
      [INLINES.HYPERLINK]: RenderHyperlink
    },
  };
  
  const descEv: any = {
    json: descripcionEvento
  } 
  
  return (
    <section className="o-club-desc">
      <h2 className="o-club-desc__title">{tituloPrincipal}</h2>
      <div className="o-club-desc__columns">
        <div className="o-club-desc__left">
          <p className="o-club-desc__left__description">
            {descripcion && descripcion.json.content[0].content[0].value}
          </p>
          {listaTags.length > 0 &&
            <ul className="o-club-desc__left__tags-items">
              {listaTags.slice(0, 10).map((subject, index) => 
                <li className="o-club-desc__left__tags-items__item" key={index}>
                  {subject}
                </li>
              )}
            </ul>
          }
          {props.referenciaCursosDestacados[0] && 
          <>
            <p className="o-club-desc__left__moderator-title">Moderador</p>
            <ClubModerator 
              picture={imagenPrincipal.file.url}
              name={nombreModerador}
              role={cargoModerador}
              phrase={fraseModerador}
              socials={redesModerador}
            />
          </>
          }
        </div>
        <div className="o-club-desc__vertical-divider"></div>
        <div className="o-club-desc__right">
          {documentToReactComponents(descEv.json , options)}
        </div>
      </div>
    </section>
  )
}

export default ClubDescription;